/**
 * Key Points de pala - PadelHouse (tema Horizon).
 *
 * Dispara el relleno de las barras (crecimiento en anchura L->R via CSS)
 * con IntersectionObserver, sin dependencias:
 *  - al cargar la pagina si el bloque ya esta visible,
 *  - cada vez que una barra VUELVE a entrar en el viewport tras hacer scroll.
 * Al salir del viewport se resetea (se quita is-inview) para que se re-anime
 * al reaparecer.
 *
 * Anade la clase .kp--js al contenedor: sin JS, el CSS deja el relleno estatico
 * a su valor (fallback accesible). Respeta prefers-reduced-motion via CSS.
 */
(function () {
  'use strict';

  function init(root) {
    var blocks = (root || document).querySelectorAll('.kp');
    Array.prototype.forEach.call(blocks, function (kp) {
      if (kp.dataset.kpReady === '1') return;
      kp.dataset.kpReady = '1';
      kp.classList.add('kp--js');

      var bars = kp.querySelectorAll('.kp__bar');

      if (!('IntersectionObserver' in window)) {
        Array.prototype.forEach.call(bars, function (bar) {
          bar.classList.add('is-inview');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );

      Array.prototype.forEach.call(bars, function (bar) {
        io.observe(bar);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function () {
    init(document);
  });
})();
